'use strict';
// Informe A/B y centro de descargas (hoja 28, hoja 01 filas 64-67, 75, 100, 127, 128, 141, 149, 152, 159, 160).
// El HTML del informe lo arma generateReport() del prototipo, literal. Acá solo se agrega lo que el prototipo hacía
// sobre el DOM (la conclusión de cada sección) y se arman los archivos de descarga sin Blob ni <a download>.
const P = require('./prototipo');
const { fijarContexto } = require('./comun');
const textos = require('./textos');

const ESTILO_CONCLUSION = 'margin-top:12px;padding:10px 14px;border-left:4px solid #003872;background:#F2F6FA;border-radius:4px;font-size:13.5px;';

const entidades = { '&amp;': '&', '&lt;': '<', '&gt;': '>', '&quot;': '"', '&#39;': "'", '&nbsp;': ' ' };
const textoPlano = (h) => String(h).replace(/<[^>]*>/g, '').replace(/&(amp|lt|gt|quot|#39|nbsp);/g, (m) => entidades[m]).trim();

// Clave de la sección según el título de su <h3> (mismas reglas que agregarConclusionesSeccion del prototipo).
function claveSeccion(titulo) {
  const m = titulo.match(/^(\d+)( bis)?\./);
  if (m) return m[1] + (m[2] ? 'bis' : '');
  if (/^Implementación de ISO 50001/.test(titulo)) return 'impl';
  return null;
}

// Agrega al final de cada <div class="report-sec"> la «Conclusión de esta sección» (salvo la 12, que ya es la
// conclusión general, y las secciones sin número: índice, resumen, anexos y fuentes).
function agregarConclusionesSeccion(f, html) {
  const apertura = /<div class="report-sec"[^>]*>/g;
  const etiquetaDiv = /<\/?div\b[^>]*>/gi;
  let salida = '';
  let desde = 0;
  let m;
  while ((m = apertura.exec(html))) {
    // cierre del div de la sección
    etiquetaDiv.lastIndex = m.index;
    let nivel = 0;
    let cierre = -1;
    let d;
    while ((d = etiquetaDiv.exec(html))) {
      nivel += d[0][1] === '/' ? -1 : 1;
      if (nivel === 0) { cierre = d.index; break; }
    }
    if (cierre < 0) break;
    const cuerpo = html.slice(m.index, cierre);
    const h3 = cuerpo.match(/<h3[^>]*>([\s\S]*?)<\/h3>/);
    const k = h3 && !/class="concl-sec"/.test(cuerpo) ? claveSeccion(textoPlano(h3[1])) : null;
    const txt = k != null && k !== '12' ? P.conclusionSeccion(f, k) : '';
    if (txt) {
      salida += html.slice(desde, cierre)
        + `<div class="concl-sec" style="${ESTILO_CONCLUSION}"><strong>Conclusión de esta sección:</strong> ${String(txt).replace(/</g, '&lt;')}</div>`;
      desde = cierre;
    }
    apertura.lastIndex = m.index + m[0].length;
  }
  return salida + html.slice(desde);
}
P._set_POST_INFORME(agregarConclusionesSeccion);

// Quien dibuja los gráficos del informe: (cfg Chart.js, g) => data URL PNG. En el navegador lo fija el cliente.
function fijarImagenGrafico(fn) { P._set_IMAGEN_GRAFICO(fn || null); }

// HTML del informe (el cuerpo que se muestra en pantalla), según el uso A/B. f ya recalculada.
function informe(f, opciones = {}) {
  fijarContexto(opciones);
  return P.generateReport(f);
}

// Documento HTML autónomo (descarga): mismo informe, con su estilo y el título según el uso.
function informeHtml(f, opciones = {}) {
  fijarContexto(opciones);
  return P._informeHtml(f);
}

// Guía paso a paso como documento autónomo (mismo estilo y título que el prototipo).
function guiaHtml() {
  const css = 'body{font-family:Arial,Helvetica,sans-serif;color:#1a1c42;max-width:900px;margin:24px auto;padding:0 18px;line-height:1.55;font-size:14px}table{border-collapse:collapse;width:100%;margin:10px 0;font-size:12.5px}th,td{border:1px solid #c9d3e0;padding:6px 8px;text-align:left;vertical-align:top}th{background:#003872;color:#fff}h2,h4{color:#003872;font-weight:700}a{color:#003872;text-decoration:none}';
  const cuerpo = textos.guia.html.replace(/<a[^>]*>/g, '').replace(/<\/a>/g, '');
  return '<!doctype html><html lang="es"><head><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1"><title>Guía paso a paso — Desempeño energético</title><style>'
    + css + '</style></head><body><h2>Guía paso a paso — cómo se completa y cómo se lee</h2>' + cuerpo + '</body></html>';
}

const utf8 = (s) => new TextEncoder().encode(s);
const MIME_HTML = 'text/html;charset=utf-8';

// Centro de descargas (DESCARGAS del prototipo). «pdf» lo resuelve quien llama (imprimir el informe).
// Cada archivo: (f) => { nombre, datos (string | Uint8Array), mime }.
const DESCARGAS = [
  {
    clave: 'informe', t: 'Informe completo (HTML)', d: 'Documento autónomo: se abre en cualquier navegador y se puede enviar por correo.',
    archivo: (f) => ({ nombre: `Sustemia_Informe_Energia_${P._slug(f)}_${P._stamp()}.html`, datos: P._informeHtml(f), mime: MIME_HTML }),
  },
  { clave: 'pdf', t: 'Informe en PDF', d: 'Abre la impresión: elegir "Guardar como PDF".', imprimir: true },
  {
    clave: 'guia', t: 'Guía paso a paso (HTML)', d: 'Cómo se completa cada pestaña y cómo se leen los resultados.',
    archivo: () => ({ nombre: 'Sustemia_Guia_Desempeno_Energetico.html', datos: guiaHtml(), mime: MIME_HTML }),
  },
  {
    clave: 'excel', t: 'Excel completo (14 hojas)', d: 'Resumen, autoevaluación ISO 50001, requisitos de detalle, mapa de cláusulas, datos mensuales, USE, operaciones, maquinaria, medidas, IDEn, recomendaciones, conclusiones, documentos y criterios.',
    archivo: (f) => ({ nombre: `Sustemia_Energia_${P._slug(f)}_${P._stamp()}.xlsx`, datos: P.libroCompleto(f), mime: P.MIME_XLSX }),
  },
  {
    clave: 'auditoria', t: 'Autoevaluación ISO 50001 (Excel)', d: 'Verificación cláusula por cláusula con evidencia y hallazgo.',
    archivo: (f) => ({
      nombre: `Sustemia_Autoevaluacion_50001_${P._slug(f)}_${P._stamp()}.xlsx`, mime: P.MIME_XLSX,
      datos: P.buildXlsx([{ name: 'Autoevaluacion ISO 50001', rows: P._datosAudit(f) }, { name: 'Mapa clausulas', rows: P._datosMapa(f) }]),
    }),
  },
  {
    clave: 'medidas', t: 'Medidas y recomendaciones (Excel)', d: 'Cartera de ahorro con inversión y payback, más las recomendaciones priorizadas.',
    archivo: (f) => ({
      nombre: `Sustemia_Medidas_${P._slug(f)}_${P._stamp()}.xlsx`, mime: P.MIME_XLSX,
      datos: P.buildXlsx([{ name: 'Medidas ECM', rows: P._datosEcm(f) }, { name: 'Recomendaciones', rows: P._datosRecs(f) }]),
    }),
  },
  {
    clave: 'datos', t: 'Datos y modelo (Excel)', d: 'Serie mensual con la línea de base, USE, operaciones y maquinaria.',
    archivo: (f) => ({
      nombre: `Sustemia_Datos_${P._slug(f)}_${P._stamp()}.xlsx`, mime: P.MIME_XLSX,
      datos: P.buildXlsx([{ name: 'Datos mensuales', rows: P._datosMensual(f) }, { name: 'USE', rows: P._datosUse(f) }, { name: 'Operaciones', rows: P._datosOper(f) }, { name: 'Maquinaria', rows: P._datosMaq(f) }]),
    }),
  },
  {
    clave: 'csv', t: 'Serie mensual (CSV)', d: 'Para abrir en cualquier planilla o sistema.',
    archivo: (f) => ({ nombre: `Sustemia_Mensual_${P._slug(f)}_${P._stamp()}.csv`, datos: P._csv(P._datosMensual(f)), mime: 'text/csv;charset=utf-8' }),
  },
  {
    clave: 'json', t: 'Instalación completa (JSON)', d: 'Se vuelve a cargar en este módulo o en el cuadro de Sustemia.',
    archivo: (f) => ({ nombre: `Sustemia_Instalacion_${P._slug(f)}_${P._stamp()}.json`, datos: JSON.stringify(P.exportSustemia(f), null, 2), mime: 'application/json' }),
  },
  {
    clave: 'modelo', t: 'Modelo de relevamiento (Excel)', d: 'Planilla con los datos actuales para completar en planta.',
    archivo: (f) => ({ nombre: `Sustemia_Modelo_Relevamiento_${f.id}.xlsx`, datos: P.modeloRelevamiento(f, false), mime: P.MIME_XLSX }),
  },
  {
    clave: 'zip', t: 'Paquete completo (.zip)', d: 'Informe HTML, Excel completo, instalación (JSON) y tres CSV (serie mensual, autoevaluación ISO 50001 y medidas) en un solo archivo.',
    archivo: (f) => {
      const base = `Sustemia_${P._slug(f)}_${P._stamp()}`;
      const files = [
        { name: base + '/Informe.html', data: utf8(P._informeHtml(f)) },
        { name: base + '/Energia_completo.xlsx', data: P.libroCompleto(f) },
        { name: base + '/Instalacion.json', data: utf8(JSON.stringify(P.exportSustemia(f), null, 2)) },
        { name: base + '/Serie_mensual.csv', data: utf8(P._csv(P._datosMensual(f))) },
        { name: base + '/Auditoria_50001.csv', data: utf8(P._csv(P._datosAudit(f))) },
        { name: base + '/Medidas.csv', data: utf8(P._csv(P._datosEcm(f))) },
      ];
      return { nombre: base + '.zip', datos: P.zipStore(files), mime: 'application/zip' };
    },
  },
];

// Arma el archivo de una descarga. f ya recalculada; opciones: { modo, fechaReferencia }.
function archivoDescarga(f, clave, opciones = {}) {
  const d = DESCARGAS.find((x) => x.clave === clave);
  if (!d || !d.archivo) throw new Error('Descarga desconocida: ' + clave);
  fijarContexto(opciones);
  P.ensureData(f);
  return d.archivo(f);
}

module.exports = { informe, informeHtml, guiaHtml, agregarConclusionesSeccion, fijarImagenGrafico, archivoDescarga, DESCARGAS };
